<template>
    <v-card
        class="pb-5"
        :width="widthProp"
        elevation="0"
        style="border-radius: 10px"
    >
        <v-card-text>
            <v-form
                v-model="student_other_detail_status"
                ref="form"
                :disabled="disabledRules"
            >
                <v-row >
                    <v-col class="py-0">
                        <div class="pt-5 prompt-title" style="padding-bottom:14px">
                            {{ $t("message.form.topics.educationalRecord") }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        :cols="columnResponsive.former_school.cols"
                        :sm="columnResponsive.former_school.sm"
                        :md="columnResponsive.former_school.md"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.educationData.formerSchool") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t(
                                    'message.form.educationData.fillFormerSchool'
                                )
                            "
                            v-model="student_other_detail.former_school_name"
                            :rules="former_school_name_Rule"
                        ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field>
                    </v-col>

                    <v-col
                        :cols="columnResponsive.former_school_province.cols"
                        :sm="columnResponsive.former_school_province.sm"
                        :md="columnResponsive.former_school_province.md"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.educationData.province") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.educationData.fillProvince')
                            "
                            v-model="
                                student_other_detail.former_school_province
                            "
                            :rules="former_school_province_Rule"
                            :items="provinces"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            @change="onChangeProvince(student_other_detail.former_school_province)"
                        ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select>
                    </v-col>

                    <v-col
                        :cols="columnResponsive.former_school_district.cols"
                        :sm="columnResponsive.former_school_district.sm"
                        :md="columnResponsive.former_school_district.md"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.educationData.district") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.educationData.fillDistrict')
                            "
                            v-model="
                                student_other_detail.former_school_district
                            "
                            :rules="former_school_district_Rule"
                            :items="districts"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            :disabled="!student_other_detail.former_school_province"
                        ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select>
                    </v-col>

                    <v-col
                        :cols="columnResponsive.former_school_GPAX.cols"
                        :sm="columnResponsive.former_school_GPAX.sm"
                        :md="columnResponsive.former_school_GPAX.md"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.educationData.gpa") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.educationData.fillGpa')
                            "
                            v-mask="'#.##'"
                            v-model="tempGPAX"
                            :rules="former_school_GPAX_Rule"
                            >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field>
                    </v-col>

                    <v-col
                        :cols="columnResponsive.former_school_last_student_year.cols"
                        :sm="columnResponsive.former_school_last_student_year.sm"
                        :md="columnResponsive.former_school_last_student_year.md"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{
                                $t("message.form.educationData.lastEducation")
                            }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            dense
                            outlined
                            readonly
                            hide-details="auto"
                            v-bind:placeholder="
                                $t(
                                    'message.form.educationData.fillLastEducation'
                                )
                            "
                            :items="availableStudentYear"
                            v-model="
                                student_other_detail.former_school_last_student_year
                            "
                            :rules="former_school_last_student_year_id_Rule"
                            :item-text="locale == 'th' ? 'student_year_name_th' : 'student_year_name_en'"
                            item-value="value"
                        ><template #message="{ message }">
                            {{ $t(message) }}
                        </template></v-select>
                    </v-col>

                    <v-col
                        :cols="columnResponsive.former_school_note.cols"
                        :sm="columnResponsive.former_school_note.sm"
                        :md="columnResponsive.former_school_note.md"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                        v-if="from == 'candidates'"
                    >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{$t('message.form.educationData.moveReason')}}
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            :placeholder="$t('message.form.educationData.fillMoveReason')"
                            v-model="student_other_detail.transfer_reason"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import i18n from '@/i18n';
export default {
    name: "StudentEducation",
    data: () => ({
        student_other_detail_status: false,
        tempGPAX: null,
        student_other_detail: {
            former_school_name: "",
            former_school_province: "",
            former_school_district: "",
            former_school_GPAX: null,
            former_school_last_student_year: "",
            transfer_reason: "",
        },
        former_school_name_Rule: [(v) => !!v || "message.form.educationData.fillFormerSchool"],
        former_school_province_Rule: [(v) => !!v || "message.form.educationData.fillProvince"],
        former_school_district_Rule: [(v) => !!v || "message.form.educationData.fillDistrict"],
        former_school_GPAX_Rule: [
            (v) => !!v || "message.form.educationData.fillGpa",
            (v) => !!v && Number(v) <= 4.00 || "message.form.educationData.errorGPALess"],
        former_school_last_student_year_id_Rule: [
            (v) => !!v || "message.form.educationData.fillLastEducation",

        ],
        GpaxRangeMask,
        student_years: [],
        provinces: [],
        districts: [],
    }),
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        async fetchInitData() {
            try {
                this.$emit("loadingUpdate", 1);
                let data = await getProvince();

                data.province.map((item) => {
                    this.provinces.push(item);
                });

                data = await getStudentYear();

                data.student_year.map((item) => {
                    if (item.value != null && item.value)
                        this.student_years.push(item);
                });

                if (this.stepActive == 5 || this.from == "candidates") {
                    await this.fetchInitStudentQuery();
                }
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        onChangeData() {
            this.$emit("formValidate", this.$refs?.form?.value);
        },
        async fetchInitStudentQuery() {
            try {
                this.$emit("loadingUpdate", 1);
                const body = {
                    query: {
                        selects: {
                            id: true,
                            student_other_detail: {
                                former_school_name: true,
                                former_school_province: true,
                                former_school_district: true,
                                former_school_GPAX: true,
                                former_school_last_student_year: true,
                                transfer_reason: true,
                            },
                        },
                        relations: {
                            student_other_detail: {
                                former_school_province: true,
                                former_school_district: true,
                                former_school_last_student_year: true,
                            },
                        },
                    },
                };
                if (this.from == "candidates") {
                    body["id"] = this.applicantId;
                } else if (this.stepActive == 5) {
                    body["token"] = localStorage.getItem("token");
                }

                const {
                    data: { data },
                } = await services.getStudentWithQuery(body);
                this.autoFillDataFromDb(data.student.student_other_detail);
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        async autoFillDataFromDb(data) {
            try {
                this.$emit("loadingUpdate", 1);
                Object.keys(data).forEach(async (key) => {
                    if (
                        key == "former_school_province" ||
                        key == "former_school_district" ||
                        key == "former_school_last_student_year"
                    ) {
                        this.student_other_detail[key] = data[key].value;
                    } else {
                        this.student_other_detail[key] = data[key];
                    }
                });
                this.tempGPAX = data["former_school_GPAX"];

                this.onChangeProvince(this.student_other_detail['former_school_province']);
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },

        getLabelStdYear (v,lang) {
            if (lang === 'th') {
                switch (v) {
                    case 99:
                        return 'อ.1'
                    case 98:
                        return 'อ.2'
                    case 97:
                        return 'อ.3'
                    case 96:
                        return 'ก่อนเตรียมอนุบาล'
                    case 95:
                        return 'เตรียมอนุบาล'
                    case 1:
                        return 'ป.1'
                    case 2:
                        return 'ป.2'
                    case 3:
                        return 'ป.3'
                    case 4:
                        return 'ป.4'
                    case 5:
                        return 'ป.5'
                    case 6:
                        return 'ป.6'
                    case 7:
                        return 'ม.1'
                    case 8:
                        return 'ม.2'
                    case 9:
                        return 'ม.3'
                    case 10:
                        return 'ม.4'
                    case 11:
                        return 'ม.5'
                    case 12:
                        return 'ม.6'
                }
            } else {
                switch (v) {
                    case 99:
                        return 'K.1'
                    case 98:
                        return 'K.2'
                    case 97:
                        return 'K.3'
                    case 96:
                        return 'Nursery'
                    case 95:
                        return 'Pre-Kindergarten'
                    case 1:
                        return 'G.1'
                    case 2:
                        return 'G.2'
                    case 3:
                        return 'G.3'
                    case 4:
                        return 'G.4'
                    case 5:
                        return 'G.5'
                    case 6:
                        return 'G.6'
                    case 7:
                        return 'G.7'
                    case 8:
                        return 'G.8'
                    case 9:
                        return 'G.9'
                    case 10:
                        return 'G.10'
                    case 11:
                        return 'G.11'
                    case 12:
                        return 'G.12'
                }
            }
        },
        async onChangeProvince(value) {
            if (!value) {
                this.districts = []
                return
            }

            try {
                this.$emit("loadingUpdate", 1);
                const { data: { data } } = await services.getDistrictByProvince(value);
                this.districts = data?.district;
            } finally{
                this.$emit("loadingUpdate", -1);
            }
        },
        setLastStudentYear() {
            if (this.stepActive == 5 || this.from == "candidates") return

            this.student_other_detail.former_school_last_student_year = this.availableStudentYear[0].value;
        },
    },
    props: {
        stepActive: Number,
        checkValidate: Boolean,
        callAutoFill: Boolean,
        targetStudentYear: Number,
        applicantId: Number,
        widthProp: {
            default: "690",
            type: String,
        },
        registrationState: {
            default: "all",
            type: String,
        },
        from: {
            default: "all",
            type: String,
        },
    },
    emits: ["formValidate"],
    computed: {
        locale(){
            return i18n.locale
        },
        disabledRules() {
            if (this.stepActive == 5 && this.$route.query.action == "view")
                return true;
            return false;
        },
        columnResponsive() {
            try {
                let columnResponsive = {
                    all: {
                        former_school: { cols: "12", sm: "6", md: "6" },
                        former_school_province: {
                            cols: "12",
                            sm: "6",
                            md: "6",
                        },
                        former_school_district: {
                            cols: "12",
                            sm: "6",
                            md: "6",
                        },
                        former_school_GPAX: {
                            cols: "12",
                            sm: "6",
                            md: "6",
                        },
                        former_school_last_student_year: {
                            cols: "12",
                            sm: "6",
                            md: "6",
                        },
                        former_school_note: {
                            cols: "12",
                            sm: "6",
                            md: "6",
                        },
                    },
                    candidates: {
                        former_school: { cols: "12", sm: "4", md: "4" },
                        former_school_province: {
                            cols: "12",
                            sm: "4",
                            md: "4",
                        },
                        former_school_district: {
                            cols: "12",
                            sm: "4",
                            md: "4",
                        },
                        former_school_GPAX: {
                            cols: "12",
                            sm: "4",
                            md: "4",
                        },
                        former_school_last_student_year: {
                            cols: "12",
                            sm: "4",
                            md: "4",
                        },
                        former_school_note: {
                            cols: "12",
                            sm: "4",
                            md: "4",
                        },
                    },
                };
                return columnResponsive[this.from];
            } catch (error) {
                console.log(error);
                return {
                    former_school: { cols: "12", sm: "4", md: "4" },
                    former_school_province: {
                        cols: "12",
                        sm: "4",
                        md: "4",
                    },
                    former_school_district: {
                        cols: "12",
                        sm: "4",
                        md: "4",
                    },
                    former_school_GPAX: { cols: "12", sm: "4", md: "4" },
                    former_school_last_student_year: {
                        cols: "12",
                        sm: "4",
                        md: "4",
                    },
                    former_school_note: { cols: "12", sm: "4", md: "4" },
                };
            }
        },
        showSectionCondition() {
            try {
                let allow_state = [
                    "SUCCESSFUL_CONFIRMATION_DETAIL",
                    "SUCCESSFUL_ENROLLMENT",
                ];
                if (this.from == "all") return false;
                if (
                    this.from == "candidates" &&
                    allow_state.includes(this.registrationState)
                )
                    return true;
                return false;
            } catch (error) {
                return false;
            }
        },
        availableStudentYear() {
            // const allStdYear = [96, 95, 99, 98, 97, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            const allStdYear = [this.getTargetStudentYear]
            const student_years = allStdYear.map((v) => (
                {
                    student_year_name_th: this.getLabelStdYear(v,'th'),
                    student_year_name_en: this.getLabelStdYear(v,'en'),
                    value: v
                }
            ))
            return student_years;
        },
        getTargetStudentYear() {
            return this.targetStudentYear - 1;
        },
    },
    watch: {
        checkValidate: function () {
            // watch it
            this.$refs.form.validate();
        },
        callAutoFill: function () {
            this.autoFill();
        },
        tempGPAX(newGPAX, oldGPAX) {
            if (Number(newGPAX) >= 4) {
                if (oldGPAX >= 4) {
                    this.tempGPAX = '4.00';
                    this.student_other_detail.former_school_GPAX = Number(
                        this.tempGPAX
                    );
                }
            } else {
                this.student_other_detail.former_school_GPAX = Number(newGPAX);
            }
        },
        availableStudentYear() {
            this.setLastStudentYear();
        }
    },
    mounted() {
        this.fetchInitData();
        this.setLastStudentYear()
    },
    updated() {
        this.onChangeData();
    },
};

export function GpaxMask(value) {
    const hours = [/[0-4]/];
    const minutes = [
        value.charAt(0) === "4" ? /0/ : /[0-9]/,
        value.charAt(0) === "4" ? /0/ : /[0-9]/,
    ];
    return value.length > 1 ? [...hours, ".", ...minutes] : hours;
}

/**
 * Generate a time range mask based on input value (00:00-23:59)
 * @param {string} value
 */
export function GpaxRangeMask(value) {
    const numbers = value.replace(/[^0-9]/g, "");
    if (numbers.length > 4) {
        return [
            ...GpaxMask(numbers.substring(0, 1)),
            ".",
            ...GpaxMask(numbers.substring(2)),
        ];
    }
    return [...GpaxMask(numbers)];
}

import * as services from "../../services";

const getProvince = async () => {
    const {
        data: { data },
    } = await services.getProvince();
    return data;
};

const getStudentYear = async () => {
    const {
        data: { data },
    } = await services.getStudentYear();
    return data;
};
</script>

<style scoped>
.form-label{
    font-size: 18px;
}
</style>
